module.exports = require('./helpers/bundle-url').getBundleURL('ax7c2') + "logo.c51670a8.svg";